var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666672 12.3334C0.666672 9.97671 0.666672 8.79754 1.39917 8.06587C2.13084 7.33337 3.31 7.33337 5.66667 7.33337H12.3333C14.69 7.33337 15.8692 7.33337 16.6008 8.06587C17.3333 8.79754 17.3333 9.97671 17.3333 12.3334C17.3333 14.69 17.3333 15.8692 16.6008 16.6009C15.8692 17.3334 14.69 17.3334 12.3333 17.3334H5.66667C3.31 17.3334 2.13084 17.3334 1.39917 16.6009C0.666672 15.8692 0.666672 14.69 0.666672 12.3334Z",
    stroke: "#433E3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 7.33335V5.66669C4 4.3406 4.52678 3.06883 5.46447 2.13115C6.40215 1.19347 7.67392 0.666687 9 0.666687C10.3261 0.666687 11.5979 1.19347 12.5355 2.13115C13.4732 3.06883 14 4.3406 14 5.66669V7.33335",
    stroke: "#433E3F",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66667 12.3334H5.67417M8.99251 12.3334H9.00001M12.3258 12.3334H12.3333",
    stroke: "#433E3F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.62a17d69fe43acc99c3606772a1ca663.svg";
export { ForwardRef as ReactComponent };